<template>
  <div v-if="isAuthenticated" style="height:100%">
    <div id="body-filter" class="body-filter" :class="{'body-filter-mobile': !isDesktop}">
      <div v-if="!isDesktop" class="mobile-filter-header">
        <div @click="clearFilter()" class="btn-clear"> {{$t('REPORT_FILTER').Clear_Filter}} </div>
        <!-- <div class="title-page" >{{$t('REPORT_FILTER').Filters}}</div> -->
        <div class="btn-close">
          <feather-icon  icon="XIcon" @click.stop="closeFilter" class="cursor-pointer close-icon-custom "></feather-icon>
        </div>
  
        <!-- <vs-button
          v-if="getNumFilterSelected() > 0"
          color="dark"
          type="line"
          icon-pack="feather"
          icon="icon-trash"
          @click="clearFilter()"
        ></vs-button> -->
      </div>
      <div
        v-if="isDesktop"
        class="flex border items-center filter-label filter-title"
      >{{$t('REPORT_FILTER').Filters}}
      </div>
      <div
        class="resultado"
        :class="{'px-6': reduceSidebar || !isDesktop}"
        @click.stop="closeFilter"
      >{{$t('REPORT_FILTER').To_View}} {{total.toLocaleString('pt-br')}} {{$t('REPORT_FILTER').Results}}</div>
      
      <div class="btn-filter-desk" :class="{'': reduceSidebar || !isDesktop}" v-if="getNumFilterSelected() > 0 && isDesktop">
          <vs-button
            color="danger"
            type="flat"
            icon-pack="feather"
            icon="icon-trash"
            @click="clearFilter()"
          >{{$t('REPORT_FILTER').Clear_Filter}}</vs-button>
        </div>
      <div class="filter-scroll-area scroll-area-v-nav-menu" style="overflow-y: auto;" :settings="settings">
        <div>
          <template v-if="!isDesktop && isAuthenticated">
            <!-- <div class="lbl-cong">
              PESQUISA POR PALAVRA CHAVE
            </div> -->
            <div class="search-field-content mt-4">
              <vs-input
                icon-no-border
                icon="icon-search"
                size="large"
                icon-pack="feather"
                :placeholder="$t('REPORT_FILTER').Search"
                v-model="selectedFilter.searchQuery"
                maxlength="128"
                class="vs-input-no-border vs-input-no-shdow-focus vs-input-no-focus w-full"
                v-on:keyup.enter="updateFilter()"
              />
              <feather-icon
                v-if="selectedFilter.searchQuery"
                class="cursor-pointer close-icon"
                icon="XIcon"
                :svgClasses="['h-5 w-5']"
                @click="clearSearchQuery"
              ></feather-icon>
            </div>
            
            <!-- <div
              class="email__labels py-4"
              :class="{'px-6': reduceSidebar || !isDesktop}"
            >
              <div class="filter-label">Exibir resultado como</div>
              <div class="email__lables-list list-filter-collapse view-option">
                <span
                  class="icons-tools-wrap"
                  :class="{'view-style-selected': isListView, 'icons-tools-wrap-mobile': !isDesktop}"
                  @click="listView()"
                >
                  <div class="options-views">
                    <feather-icon icon="ListIcon" :svgClasses="['']" class="icon-view-lista"></feather-icon>
                    <div class="options-label">Lista</div>
                  </div>
                </span>
                <span
                  class="icons-tools-wrap"
                  :class="{'view-style-selected': isListViewDetailed, 'icons-tools-wrap-mobile': !isDesktop}"
                  @click="listViewDetailed()"
                >
                  <div class="options-views">
                    <feather-icon icon="FileTextIcon" :svgClasses="['']" class="icon-view-lista"></feather-icon>
                    <div class="options-label">Lista Detalhada</div>
                  </div>
                </span>
                <span
                  v-if="isDesktop"
                  class="icons-tools-wrap"
                  :class="{'view-style-selected': isCardView, 'icons-tools-wrap-mobile': !isDesktop}"
                  @click="cardView()"
                >
                  <div class="options-views">
                    <feather-icon icon="GridIcon" :svgClasses="['']" class="icon-view-cards"></feather-icon>
                    <div class="options-label">Cards</div>
                  </div>
                </span>
              </div>
            </div> -->

          </template>
        </div>
        <div class="lbl-cong" v-if="!isDesktop">
          {{$t('REPORT_FILTER').Advanced_Filters}}
        </div>
        <vs-divider class="filter-divider" v-if="canDisplaySubjectFilter && !isCalendarContent"></vs-divider>
        <div
          v-if="isDesktop && !isCalendarContent"
          class="filter-item"
          :class="{'': reduceSidebar || !isDesktop}"
        >
          <label class="filter-label">{{$t('REPORT_FILTER').Filter_Author}}</label>
          <v-select autocomplete :closeOnSelect="false" v-model="selectedFilter.users" :options="filterUsers" @input="updateFilter" class="filter-author w-full">
            <!-- <template slot="option" slot-scope="item">
              <div class="flex">
                <div>
                  <vs-avatar :src="item.image_path" v-if="item.image_path"/>
                  <vs-avatar src="@/assets/images/portrait/small/avatar-default.jpg" v-if="!item.image_path"/>
                </div>
                <div>
                  <span>{{item.name}}</span>
                  <vs-divider></vs-divider>
                  <small>{{item.email}}</small>
                </div>
              </div>
            </template> -->
          </v-select>
        </div>
        
        <div class="filter-item" :class="{'': reduceSidebar || !isDesktop}" v-if="isAuthenticated && !isCalendarContent" style="margin-top: 10px;">
          <div class="filter-label">{{$t('REPORT_FILTER').Filter_Order_By}}</div>
          <div class="item">
            <div @click="selectRelevantFilter()">
              <vs-chip
                class="cursor-pointer filter-chip"
                :class="{'exclusive-selected-filter' : selectedFilter.relevant}">
                {{$t('REPORT_FILTER').Filter_Relevant}}
              </vs-chip>
            </div>
          </div>
        </div>

        <!-- <div class="filter-item" :class="{'': reduceSidebar || !isDesktop}" v-if="isAuthenticated">
          <div class="filter-label">{{$t('REPORT_FILTER').Filter_Relevant}}</div>
          <div class="item">
            <div @click="selectRelevantLastDayFilter()">
              <vs-chip
                class="cursor-pointer filter-chip"
                :class="{'exclusive-selected-filter' : selectedFilter.relevantLastDay}"
              >
                {{$t('REPORT_FILTER').Filter_Relevant_Last_Day}}
              </vs-chip>
            </div>
            <div @click="selectRelevantLastWeekFilter()">
              <vs-chip
                class="cursor-pointer filter-chip"
                :class="{'exclusive-selected-filter' : selectedFilter.relevantLastWeek}"
              >
                {{$t('REPORT_FILTER').Filter_Relevant_Last_Week}}
              </vs-chip>
            </div>
          </div>
        </div> -->

        <vs-divider class="filter-divider" v-if="isAuthenticated && !isCalendarContent"></vs-divider>

        <div class="filter-item" v-if="isAuthenticated && !isCalendarContent">
          <div class="filter-label">{{$t('REPORT_FILTER').Filter_Date}}</div>
          <div class="item">
          <div
            v-for="(item, index) in filterDateOptions"
            :key="index"
            @click="onSelectFilterDate(item)"
          >
            <vs-chip
              class="cursor-pointer filter-chip"
              :class="{'country-selected-filter' : isFilterDateSelected(item)}"
            >{{item.name}}</vs-chip>
          </div>
        </div>
          <div
            v-if="displayCalendar"
            class="email__lables-list filter-list-data filter-list-data-collapse"
            :class="{'filter-date-reduced': reduceSidebar, 'filter-date-mobile': !isDesktop,  'filter-date-desktop': isDesktop}"
          >
            <div class="filter-date">
              <label class="label-date">{{$t('REPORT_FILTER').Filter_Date_From}}</label>              
              <datepicker
                placeholder="De"
                v-model="fromDate"
                format="dd/MM/yyyy"
                :language="languages['ptBR']"
                :clear-button="true"
                @selected="onFromChange"
                id="datepicker-from"
              ></datepicker>
            </div>
            <div class="filter-date">
              <label class="label-date">{{$t('REPORT_FILTER').Filter_Date_To}}</label>
              <!-- <v-select
                name="selectFilterDateTo"
                label="name"
                v-model="selectedFilter.selectFilterDateTo"
                :options="filterDateOptions"
                :reduce="item => item.id"
              /> -->
              <datepicker
                placeholder="Até"
                v-model="toDate"
                format="dd/MM/yyyy"
                :clear-button="true"
                :language="languages['ptBR']"
                :disabled-dates="disabledDates()"
                calendar-class="filter-calendar-date-to"
                @selected="onToChange"
              ></datepicker>
            </div>
          </div>
        </div>

        <vs-divider class="filter-divider" v-if="canDisplaySubjectFilter"></vs-divider>
        <div
          v-if="canDisplaySubjectFilter"
          class="filter-item"
          :class="{'': reduceSidebar || !isDesktop}"
        >
          <label class="filter-label">{{$t('REPORT_FILTER').Filter_Subject}}</label>
          <div class="item">
            <div
              v-for="(item, index) in getSubjects"
              :key="index"
              @click="selectSubjectFilter(item)"
            >
              <vs-chip
                class="cursor-pointer filter-chip"
                :class="{'disabled-item': item.isDisabled, 'country-selected-filter' : isSubjectFilterSelected(item)}"
              >{{item.name}}</vs-chip>
              <!-- <vx-tooltip :text="tooltipText(item)" :disabled="item.isDisabled" position="left"></vx-tooltip> -->
            </div>
          </div>
        </div>
        <vs-divider class="filter-divider" v-if="canDisplayContentFilter"></vs-divider>
        <div
          v-if="canDisplayContentFilter"
          class="filter-item"
          :class="{'': reduceSidebar || !isDesktop}"
        >
          <div class="filter-label">{{$t('REPORT_FILTER').Filter_Content}}</div>
          <div class="item">
            <div
              v-for="(item, index) in getContents"
              :key="index"
              @click="selectContentFilter(item)"
            >
              <vs-chip
                class="cursor-pointer filter-chip"
                :class="{'disabled-item': !item.habilitado, 'country-selected-filter' : isContentFilterSelected(item)}"
              >{{item.nome}}</vs-chip>
              <!-- <vx-tooltip :text="tooltipText(item)" :disabled="item.habilitado" position="left"></vx-tooltip> -->
            </div>
          </div>
        </div>
        <vs-divider class="filter-divider"></vs-divider>
        <div class="filter-item" :class="{'': reduceSidebar || !isDesktop}" v-if="isAuthenticated && !isCalendarContent">
          <div class="filter-label">{{$t('REPORT_FILTER').Filter_Media_type}}</div>
          <div class="item">
            <div @click="selectAttachmentFilter()">
              <vs-chip
                class="cursor-pointer filter-chip"
                :class="{'exclusive-selected-filter' : selectedFilter.attachment}"
              >
                {{$t('REPORT_FILTER').Filter_Attachment}}
                <feather-icon icon="PaperclipIcon" :svgClasses="['w-3 h-3']" ></feather-icon>
              </vs-chip>
            </div>
            <div @click="selectVideoFilter()">
              <vs-chip
                class="cursor-pointer filter-chip"
                :class="{'exclusive-selected-filter' : selectedFilter.video}"
              >
                {{$t('REPORT_FILTER').Filter_Video}}
                <feather-icon icon="VideoIcon" :svgClasses="['w-3 h-3']" ></feather-icon>
              </vs-chip>
            </div>
            <div @click="selectAudioFilter()">
              <vs-chip
                class="cursor-pointer filter-chip"
                :class="{'exclusive-selected-filter' : selectedFilter.audio}"
              >
                {{$t('REPORT_FILTER').Filter_Audio}}
                <feather-icon icon="MicIcon" :svgClasses="['w-3 h-3']" ></feather-icon>
              </vs-chip>
            </div>
            <div @click="selectPodcastFilter()">
              <vs-chip
                class="cursor-pointer filter-chip"
                :class="{'exclusive-selected-filter' : selectedFilter.podcast}"
              >
                {{$t('REPORT_FILTER').Filter_Podcast}}
                <feather-icon icon="MicIcon" :svgClasses="['w-3 h-3']" ></feather-icon>
              </vs-chip>
            </div>
          </div>
        </div>
        <vs-divider class="filter-divider" v-if="isAuthenticated && !isCalendarContent"></vs-divider>
        <div
          v-if="isAuthenticated"
          class="filter-item"
          :class="{'': reduceSidebar || !isDesktop}"
        >
          <div class="filter-label">{{$t('REPORT_FILTER').Filter_Country}}</div>
          <div class="item">
            <div
              v-for="(item, index) in country"
              :key="index"
              @click="selectCountryFilter(item)"
            >
              <vx-tooltip :text="tooltipText(item)" :disabled="item.habilitado" position="left">
                <vs-chip
                  class="cursor-pointer filter-chip"
                  :class="{'disabled-item': !item.habilitado, 'country-selected-filter' : isCountryFilterSelected(item)}"
                >{{item.nome}}</vs-chip>
              </vx-tooltip>
            </div>
          </div>
        </div>
        <!-- <div
          v-if="isAuthenticated && topic.length > 0"
          class="filter-item"
          :class="{'': reduceSidebar || !isDesktop}"
        >
          <vs-divider class="filter-divider" v-if="isAuthenticated"></vs-divider>
          <div class="filter-label">topic</div>
          <div class="item">
            <div
              v-for="(item, index) in topic"
              :key="index"
              @click="selectTopicFilter(item)"
            >
              <vx-tooltip :text="tooltipText(item)" :disabled="item.habilitado" position="left">
                <vs-chip
                  class="cursor-pointer filter-chip"
                  :class="{'disabled-item': !item.habilitado, 'country-selected-filter' : isTopicFilterSelected(item)}"
                >{{item.nome}}</vs-chip>
              </vx-tooltip>
            </div>
          </div>
        </div> -->
        <vs-divider v-if="!displayConsultingField && !displayNewsField && isAuthenticated" class="filter-divider"></vs-divider>
        <div
          class="filter-item"
          :class="{'': reduceSidebar || !isDesktop}"
          v-if="!displayConsultingField && !displayNewsField && isAuthenticated && !isCalendarContent && periodicity && periodicity.length > 0"
        >
          <div class="filter-label">{{$t('REPORT_FILTER').Filter_Periodicity}}</div>
          <div class="item">
            <div
              v-for="(item, index) in periodicity"
              :key="index"
              @click="selectPeriodicityFilter(item)"
            >
              <vx-tooltip :text="tooltipText(item)" :disabled="item.habilitado" position="left">
                <vs-chip
                  class="cursor-pointer filter-chip"
                  :class="{'disabled-item': !item.habilitado, 'country-selected-filter' : isPeriodicityFilterSelected(item)}"
                >{{item.nome}}</vs-chip>
              </vx-tooltip>
            </div>
          </div>
        </div>
        <vs-divider v-if="isAuthenticated && !displayConsultingField && !displayNewsField && !isCalendarContent" class="filter-divider"></vs-divider>
        <div class="filter-item" v-if="isAuthenticated && !isCalendarContent">
          <div class="filter-label">{{$t('REPORT_FILTER').Filter_Publication_Type}}</div>
          <div class="item">
            <div
              v-for="(item, index) in characteristic"
              :key="index"
              @click="selectCharacteristicFilter(item)"
            >
              <vx-tooltip :text="tooltipText(item)" :disabled="item.habilitado" position="left">
                <vs-chip
                  class="cursor-pointer filter-chip"
                  :class="{'disabled-item': !item.habilitado, 'country-selected-filter' : isCharacteristicFilterSelected(item)}"
                >{{item.nome}}</vs-chip>
              </vx-tooltip>
            </div>
          </div>
        </div>
        <vs-divider class="filter-divider" v-if="isAuthenticated && !isCalendarContent"></vs-divider>
        <div class="filter-item" v-if="isAuthenticated && !isCalendarContent">
          <div class="filter-label">{{$t('REPORT_FILTER').Filter_Priority}}</div>
          <div class="item">
            <div @click="selectHighlightFilter()">
              <vs-chip
                class="cursor-pointer filter-chip"
                :class="{'highlights-selected-filter' : selectedFilter.highlights}"
              >{{$t('REPORT_FILTER').Filter_Highlights}}</vs-chip>
            </div> 
            <div @click="selectInLiveFilter()">
              <vs-chip
                class="cursor-pointer filter-chip"
                :class="{'highlights-selected-filter' : selectedFilter.inLive}"
              >{{$t('REPORT_FILTER').Filter_InLive}}</vs-chip>
            </div> 
                
            <div @click="selectImportantFilter()">
              <vs-chip
                class="cursor-pointer filter-chip"
                :class="{'important-selected-filter' : selectedFilter.important}"
              >{{$t('REPORT_FILTER').Filter_Important}}</vs-chip>
            </div>
            <div @click="selectExclusiveFilter()" v-if="exclusive">
              <vs-chip
                class="cursor-pointer filter-chip"
                :class="{'exclusive-selected-filter' : selectedFilter.exclusive}"
              >
                {{$t('REPORT_FILTER').Filter_Exclusive}}
                <!-- <feather-icon icon="Icon" :svgClasses="['w-4 h-4']" ></feather-icon> -->
              </vs-chip>
            </div>
            <div @click="selectDisclosureAnnouncementFilter()">
              <vs-chip
                class="cursor-pointer filter-chip"
                :class="{'exclusive-selected-filter' : selectedFilter.disclosureAnnouncement}"
              >
                {{$t("BADGES").Announcement}}
              </vs-chip>
            </div>
            <div @click="selectDisclosureInviteFilter()">
              <vs-chip
                class="cursor-pointer filter-chip"
                :class="{'exclusive-selected-filter' : selectedFilter.disclosureInvite}"
              >
                {{$t("BADGES").Invite}}
              </vs-chip>
            </div>
          </div>
        </div>
        <div class="filter-item" v-if="isAuthenticated && isCalendarContent">
          <div class="filter-label">Tipo</div>
          <div class="item">
             <div @click="selectDisclosureAnnouncementFilter()">
              <vs-chip
                class="cursor-pointer filter-chip"
                :class="{'exclusive-selected-filter' : selectedFilter.disclosureAnnouncement}"
              >
                {{$t("BADGES").Announcement}}
              </vs-chip>
            </div>
            <div @click="selectDisclosureInviteFilter()">
              <vs-chip
                class="cursor-pointer filter-chip"
                :class="{'exclusive-selected-filter' : selectedFilter.disclosureInvite}"
              >
                {{$t("BADGES").Invite}}
              </vs-chip>
            </div>
            
          </div>
        </div>


        
      </div>
    </div>
    <div v-if="!isDesktop" class="v-nav-menu-swipe-area" v-hammer:swipe.right="onClose"></div>
  </div>

  <div style="height:100%" v-else>
    <custom-content
      :isDesktop="isDesktop" 
      @close="closeFilter"
      @open-register="$emit('open-register')"
    />
  </div>
</template>

<script>
import CustomContent from "../CustomContent.vue";
import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";
import _ from "lodash";
import AppConstants from "../../../appConstants";
import { EventBus } from "../../../event-bus";
import messageDialogHelper from "../../../helpers/message-dialog-helper";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
// import VueSimpleSuggest from 'vue-simple-suggest'
import vSelect from "vue-select";
import translateFieldHelper from '../../../helpers/translate-field-helper';
import { CONTENT } from '../../../enums/enum-content';
import generalHelper from "../../../helpers/general-helper";

export default {
  props: {
    filterContent: null,
    reduceSidebar: {
      type: Boolean,
      default: false
    },
    characteristic: {
      type: Array,
      required: true
    },
    periodicity: {
      type: Array,
      required: true
    },
    country: {
      type: Array,
      required: true
    },
    topic: {
      type: Array,
      required: true
    },
    reportTypeFilter: {
      type: Array
    },
    exclusive: {
      type: Boolean,
      default: false
    },
    total: 0, 
    isConsulting: Boolean,
    isNews: Boolean,
    isWeather: Boolean,
    isQuotes: Boolean,
    contents: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.5
      },
      componentVisible: true,
      languages: lang,
      fromDate: null,
      toDate: null,
      selectedFilter: {
        searchQuery: "",
        users: null,
        subject: [],
        content: [],
        characteristic: [],
        periodicity: [],
        country: [],
        topic: [],
        fromDate: null,
        toDate: null,
        highlights: false,
        inLive: false,
        important: false,
        exclusive: false,
        attachment: false,
        audio: false,
        video: false,
        podcast: false,
        relevant: false,
        reportType: [],
        selectFilterDate: null,
        disclosureAnnouncement: false,
        disclosureInvite: false
      },
      filterDateOptions: translateFieldHelper.getFilterDateList(),
      displayCalendar: false,
    };
  },
  components: {
    Datepicker,
    VuePerfectScrollbar,
    CustomContent,
    vSelect
  },
  methods: {
    onClose() {
      this.$emit('closeFilter');
    },
    isFilterDateSelected(item) {
      return this.selectedFilter.selectFilterDate == item.id;
    },
    onSelectFilterDate(item) {
      if (this.selectedFilter.selectFilterDate == item.id) {
        this.selectedFilter.selectFilterDate = null;
      } else {
        this.selectedFilter.selectFilterDate = item.id;
      }
      if (this.selectedFilter.selectFilterDate != AppConstants.FILTER_DATE_OPTION.Others) {
        this.displayCalendar = false;
        this.updateFilter();
      } else {
        this.displayCalendar = true;
      }
      this.$forceUpdate();
    },
    clearSearchQuery() {
      this.selectedFilter.searchQuery = "";
      this.updateFilter();
    },
    listView() {
      this.$store.dispatch(
        "reportListStyle",
        AppConstants.REPORT_VIEW_STYLE.LISTVIEW
      );
    },
    listViewDetailed() {
      this.$store.dispatch(
        "reportListStyle",
        AppConstants.REPORT_VIEW_STYLE.LISTVIEW_DETAILED
      );
    },
    cardView() {
      this.$store.dispatch(
        "reportListStyle",
        AppConstants.REPORT_VIEW_STYLE.CARDVIEW
      );
    },
    tooltipText(item) {
      // console.log('[tooltipText filter]', item)
      if (item.habilitado) {
        return item.nome;
      }

      return "Sem direito";
    },
    openUserRightsModal(item) {
      messageDialogHelper.displayUserRightsMessage(item.nome, () => {
        EventBus.$emit(AppConstants.BUS_EVENT_OPENA_ATTENDANCE);
      });
    },
    selectCharacteristicFilter(characteristic) {
      if (!characteristic.habilitado) {
        this.openUserRightsModal(characteristic);
        return;
      }
    
      if (!this.selectedFilter.characteristic) {
        this.selectedFilter.characteristic = [];
      }
      
      if (this.selectedFilter.characteristic.length > 0) {
        const index = this.selectedFilter.characteristic.findIndex(item => item.id == characteristic.id);
        if (index >= 0) { 
          this.selectedFilter.characteristic.splice(index, 1);
        } else {
          this.selectedFilter.characteristic.push(characteristic);
        }
      } else {
        this.selectedFilter.characteristic.push(characteristic);
      }
      this.updateFilter();
    },
    selectPeriodicityFilter(periodicity) {
      //   console.log("selected: ", periodicity);
      if (!periodicity.habilitado) {
        this.openUserRightsModal(periodicity);
        return;
      }

      if (!this.selectedFilter.periodicity) {
        this.selectedFilter.periodicity = [];
      }

      if (this.selectedFilter.periodicity.length > 0) {
        const index = this.selectedFilter.periodicity.findIndex(item => item.id == periodicity.id);
        if (index >= 0) { 
          this.selectedFilter.periodicity.splice(index, 1);
        } else {
          this.selectedFilter.periodicity.push(periodicity);
        }
      } else {
        this.selectedFilter.periodicity.push(periodicity);
      }

      this.updateFilter();
    },
    selectContentFilter(content) {
      if (!content.habilitado) {
        this.openUserRightsModal(content);
        return;
      }

      if (!this.selectedFilter.content) {
        this.selectedFilter.content = [];
      }
      if (this.selectedFilter.content.length > 0) {
        const index = this.selectedFilter.content.findIndex(item => item.id == content.id);
        if (index >= 0) { 
          this.selectedFilter.content.splice(index, 1);
        } else {
          this.selectedFilter.content.push(content);
        }
      } else {
        this.selectedFilter.content.push(content);
      }

      this.updateFilter();
    },
    selectSubjectFilter(subject) {
      if (subject.isDisabled) {
        this.openUserRightsModal(subject);
        return;
      }

      // this.$store.dispatch('updateCurrentCommodity', item);
      // this.$router.push({params: {commodity: item.id}});

      if (!this.selectedFilter.subject) {
        this.selectedFilter.subject = [];
      }
      
      if (this.selectedFilter.subject.length > 0) {
        const index = this.selectedFilter.subject.findIndex(item => item.id == subject.id);
        if (index >= 0) { 
          this.selectedFilter.subject.splice(index, 1);
        } else {
          this.selectedFilter.subject.push(subject);
        }
      } else {
        this.selectedFilter.subject.push(subject);
      }

      this.updateFilter();
   
    },
    selectCountryFilter(country) {
      if (!country.habilitado) {
        this.openUserRightsModal(country);
        return;
      }

      if (!this.selectedFilter.country) {
        this.selectedFilter.country = [];
      }
      if (this.selectedFilter.country.length > 0) {
        const index = this.selectedFilter.country.findIndex(item => item.id == country.id);
        if (index >= 0) { 
          this.selectedFilter.country.splice(index, 1);
        } else {
          this.selectedFilter.country.push(country);
        }
      } else {
        this.selectedFilter.country.push(country);
      }

      this.updateFilter();
    },
    selectTopicFilter(topic) {
      if (!topic.habilitado) {
        this.openUserRightsModal(topic);
        return;
      }

      if (!this.selectedFilter.topic) {
        this.selectedFilter.topic = [];
      }
      if (this.selectedFilter.topic.length > 0) {
        const index = this.selectedFilter.topic.findIndex(item => item.id == topic.id);
        if (index >= 0) { 
          this.selectedFilter.topic.splice(index, 1);
        } else {
          this.selectedFilter.topic.push(topic);
        }
      } else {
        this.selectedFilter.topic.push(topic);
      }

      this.updateFilter();
    },
    selectHighlightFilter() {
      this.selectedFilter.highlights = !this.selectedFilter.highlights;
      this.updateFilter();
    },
    selectInLiveFilter() {
      this.selectedFilter.inLive = !this.selectedFilter.inLive;
      this.updateFilter();
    },
    selectImportantFilter() {
      this.selectedFilter.important = !this.selectedFilter.important;
      this.updateFilter();
    },
    selectExclusiveFilter() {
      this.selectedFilter.exclusive = !this.selectedFilter.exclusive;
      this.updateFilter();
    },
    selectDisclosureAnnouncementFilter() {
      this.selectedFilter.disclosureAnnouncement = !this.selectedFilter.disclosureAnnouncement;
      this.updateFilter();
    },
    selectDisclosureInviteFilter() {
      this.selectedFilter.disclosureInvite = !this.selectedFilter.disclosureInvite;
      this.updateFilter();
    },
    selectAttachmentFilter() {
      this.selectedFilter.attachment = !this.selectedFilter.attachment;
      this.updateFilter();
    },
    selectVideoFilter() {
      this.selectedFilter.video = !this.selectedFilter.video;
      this.updateFilter();
    },
    selectAudioFilter() {
      this.selectedFilter.audio = !this.selectedFilter.audio;
      this.updateFilter();
    },
    selectPodcastFilter() {
      this.selectedFilter.podcast = !this.selectedFilter.podcast;
      this.updateFilter();
    },
    selectRelevantFilter() {
      this.selectedFilter.relevant = !this.selectedFilter.relevant;
      this.updateFilter();
    },
    isCharacteristicFilterSelected(item) {
      if (this.selectedFilter.characteristic) {
        return this.selectedFilter.characteristic.findIndex(c => c.id == item.id) >= 0;
      }
      return false;
    },
    isPeriodicityFilterSelected(item) {
      if (this.selectedFilter.periodicity) {
        return this.selectedFilter.periodicity.findIndex(p => p.id == item.id) >= 0;
      }
      return false;
    },
    isSubjectFilterSelected(item) {
      if (this.selectedFilter.subject) {
        return this.selectedFilter.subject.findIndex(p => p.id == item.id) >= 0;
      }
      return false;
    },
    isCountryFilterSelected(item) {
      if (this.selectedFilter.country) {
        return this.selectedFilter.country.findIndex(p => p.id == item.id) >= 0;
      }
      return false;
    },
    isTopicFilterSelected(item) {
      if (this.selectedFilter.topic) {
        return this.selectedFilter.topic.findIndex(p => p.id == item.id) >= 0;
      }
      return false;
    },
    isContentFilterSelected(item) {
      if (this.selectedFilter.content) {
        return this.selectedFilter.content.findIndex(p => p.id == item.id) >= 0;
      }
      return false;
    },
    onFromChange(selectedDate) {
      //   console.log(selectedDate);
      this.selectedFilter.fromDate = selectedDate;
      this.updateFilter();
    },
    onToChange(selectedDate) {
      this.selectedFilter.toDate = selectedDate;
      this.updateFilter();
    },
    clearFilter() {

      generalHelper.clearFilterFields(this.selectedFilter);
      // if (
      //   !this.selectedFilter.characteristic.length &&
      //   !this.selectedFilter.periodicity.length &&
      //   !this.selectedFilter.country.length &&
      //   !this.selectedFilter.topic.length &&
      //   !this.selectedFilter.content.length &&
      //   !this.selectedFilter.subject.length &&
      //   !this.selectedFilter.users &&
      //   !this.selectedFilter.fromDate &&
      //   !this.selectedFilter.toDate &&
      //   !this.selectedFilter.highlights &&
      //   !this.selectedFilter.inLive &&
      //   !this.selectedFilter.important &&
      //   !this.selectedFilter.exclusive &&
      //   !this.selectedFilter.attachment &&
      //   !this.selectedFilter.video &&
      //   !this.selectedFilter.podcast &&
      //   !this.selectedFilter.audio &&
      //   !this.selectedFilter.disclosureInvite &&
      //   !this.selectedFilter.disclosureAnnouncement &&
      //   !this.selectedFilter.relevant &&
      //   !this.selectedFilter.searchQuery
      // ) {
      //   return; 
      // }

      // //   this.selectedFilter.content = AppConstants.INFORMATIVE_FILTER_ALL_OPTION;
      // this.selectedFilter.characteristic = [];
      // this.selectedFilter.periodicity = [];
      // this.selectedFilter.country = [];
      // this.selectedFilter.topic = [];
      // this.selectedFilter.content = [];
      // this.selectedFilter.subject = [];
      // this.selectedFilter.users = null;
      // this.selectedFilter.fromDate = null;
      // this.selectedFilter.toDate = null;
      // this.selectedFilter.highlights = false;
      // this.selectedFilter.inLive = false;
      // this.selectedFilter.important = false;
      // this.selectedFilter.exclusive = false;
      // this.selectedFilter.selectFilterDate = null;
      // this.selectedFilter.attachment = false;
      // this.selectedFilter.video = false;
      // this.selectedFilter.podcast = false;
      // this.selectedFilter.audio = false;
      // this.selectedFilter.disclosureInvite = false;
      // this.selectedFilter.disclosureAnnouncement = false;
      // this.selectedFilter.relevant = false;
      // if (this.selectedFilter.searchQuery) {
      //   this.selectedFilter.searchQuery = "";
      // }

      this.fromDate = null;
      this.toDate = null;


      this.updateFilter();
      setTimeout(() => {
        this.closeFilter();
      }, 300);
    },
    updateFilter() {
      if (!this.isDesktop) {
        this.$vs.loading({
          container: "#body-filter",
          scale: 0.6
        });
      }
      this.$forceUpdate();
      this.$emit("updateFilter", { selectedFilter: this.selectedFilter });
      if (!this.isDesktop) { 
        setTimeout(() => {
          this.$vs.loading.close("#body-filter > .con-vs-loading");
        }, 500);
      }
    },
    getNumFilterSelected() {
      let badge = 0;
      Object.keys(this.selectedFilter).forEach(key => {
        if (key != "content") {
          if (key == "characteristic" || key == "periodicity" || key == "country" || key == "topic" || key == "subject" || key == "content") {
            badge += this.selectedFilter[key].length;
          } else if (this.selectedFilter[key]) {
            badge++;
          }
        }
      });

      return badge;
    },
    disabledDates() {
      return {
        to: this.fromDate
      };
    },
    closeFilter() {
      this.$emit("closeFilter", true);
    },
  },
    
  watch: {
    "selectedFilter.searchQuery"() {
      // this.debouncedGetAnswer();
    },
    "$i18n.locale"(value) {
      this.filterDateOptions = translateFieldHelper.getFilterDateList()
    },
  },
  computed: {
    isCalendarContent() {
      if (this.currentContent && this.currentContent.id == CONTENT.CALENDAR) {
        return true
      }
      return false;
    },
    filterUsers() {
      return this.$store.state.filterUsers.map(item => {
        return {
          value: item.id,
          label: item.name,
          name: item.name,
          email: item.email
        }
      });
    },
    contentPrivate() {
      return this.$store.state.contentPrivate || {text: ''};
    },
    isAuthenticated() {
      return this.$store.state.isAuthenticated;
    },
    canDisplaySubjectFilter() {
      if (this.currentCommodity.id) {
        return false;
      }
      return true;
    },
    canDisplayContentFilter() {
      if (this.currentContent && this.currentContent.id && !this.isCalendarContent) {
        return false;
      }
      return true;
    },
    currentCommodity() {
      return this.$store.state.currentCommodity;
    },
    currentContent() {
      return this.$store.state.currentContent;
    },
    getContents() {
      if (this.isCalendarContent) {
        return this.contents.filter(item => !item.isLabel && item.habilitado && !!item.id && (
          item.id == CONTENT.CONSULTING ||
          item.id == CONTENT.NEWS ||
          item.id == CONTENT.CONSULTING_COURSES ||
          item.id == CONTENT.CONSULTING_SPEECHES
        ));
      }
      return this.contents.filter(item => !item.isLabel && item.habilitado && !!item.id && !item.isQuotes);
    },
    getSubjects() {
      return this.$store.state.subjectsMenu[0].items.filter(item => !item.isDisabled && !!item.id);
    },
    isListView() {
      return (
        this.$store.state.reportViewStyle ==
        AppConstants.REPORT_VIEW_STYLE.LISTVIEW
      );
    },
    isListViewDetailed() {
      return (
        this.$store.state.reportViewStyle ==
        AppConstants.REPORT_VIEW_STYLE.LISTVIEW_DETAILED
      );
    },
    isCardView() {
      return (
        this.$store.state.reportViewStyle ==
        AppConstants.REPORT_VIEW_STYLE.CARDVIEW
      );
    },
    displayConsultingField() {
      return this.isConsulting || this.isWeather;
    },
    displayNewsField() {
      return this.isNews;
    },
    isDesktop() {
      return this.$store.state.isDesktop;
    },
  },
  mounted() {
    console.log('[mounted filter] ');
  },
  created() {
    console.log('created filter: ', this.$el);
    // console.log('created informative filter')
    this.$emit('changeVisible', true);
    this.debouncedGetAnswer = _.debounce(this.updateFilter, 500);

    // console.log('created: ', this.filterContent);
    if (Object.keys(this.filterContent).length > 0) {
      this.selectedFilter = this.filterContent;

      if (this.selectedFilter.fromDate) {
        this.fromDate = this.selectedFilter.fromDate;
      }

      if (this.selectedFilter.toDate) {
        this.toDate = this.selectedFilter.toDate;
      }
    }
    
  },
  beforeDestroy() {
    this.$emit('changeVisible', false);
  }
};
</script>

<style lang="scss">
.mobile-filter-header {
  
  display: flex;
  justify-content: space-between;

  .title-page {
    align-self: center;
  }
  .icon-back {
    margin-right: 10px;
  }
  .btn-clear {
    margin-left: 10px;
  }
}


.filter-title {
  margin-top: 5px;
  margin-left: 10px;
}
.filter-list-data-collapse .vdp-datepicker input {
  font-size: 12px;
}
.filter-date {
  width: 100%;
  margin-right: 10px;
  .vdp-datepicker {}
  .vdp-datepicker .vdp-datepicker__clear-button {
    top: 10px;
  }
}
.filter-date-reduced {
  .vdp-datepicker input {
    margin-left: 0px;
    width: 125px;
  }
}
.filter-date-mobile {
  .vdp-datepicker input {
    // width: 130px !important;
    width: 100% !important;
    margin-right: 20px !important;
  }
}

span.icons-tools-wrap {
  display: grid;
  /* text-align: center; */
  font-size: 0.8rem;
  margin-right: 10px;
}
.email__lables-list.list-filter-collapse.view-option {
  display: flex;
}
.options-views {
  // margin-right: 10px;
}
.options-label {
  font-size: 0.7rem;
  margin-top: -6px;
}

.view-style-selected {
  opacity: 1 !important;
  background-color: #efefef;
}
.options-views {
  margin-right: 5px;
  margin-left: 5px;
  text-align: center;
  padding-top: 10px;
}
span.icons-tools-wrap {
  display: grid;
  /* text-align: center; */
  font-size: 0.8rem;
  margin-right: 10px;
}
.email__lables-list.list-filter-collapse.view-option {
  display: flex;
}
.options-views {
  // margin-right: 10px;
}
.options-label {
  font-size: 0.7rem;
  margin-top: -6px;
}

.view-style-selected {
  opacity: 1 !important;
  background-color: #cde0a5;
}
.options-views {
  margin-right: 5px;
  margin-left: 5px;
}

span.icon-view-cards svg {
  padding-left: 3px;
}
.options-views .options-label {
  color: #000000;
  line-height: 10px;
  margin-top: 0px;
  margin-bottom: 5px;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #878d8d8d;
  opacity: 1; /* Firefox */
}

:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #878d8d8d;
}

::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #878d8d8d;
}

@import "@/assets/scss/vuexy/extraComponents/autocomplete.scss";

.vue-simple-suggest {
  .suggestions {
    position: absolute;
    z-index: 9999;
    background-color: #fff;
  }
}
</style>
